import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorMotherBoardsSocket,
  fetchProcessorMotherBoardSocketsAttributes,
  fetchProcessorMotherBoardsSocketById,
  updateProcessorMotherBoardsSocket,
  updateStatusInProcessorMotherBoardsSocket,
} from "./thunk";

interface CategoryState {
  processor_motherboardsocket_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_motherboardsocket_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "processor_motherboards_socket",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorMotherBoardSocketsAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorMotherBoardSocketsAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_motherboardsocket_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorMotherBoardSocketsAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Categories";
      })
      .addCase(fetchProcessorMotherBoardsSocketById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorMotherBoardsSocketById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorMotherBoardsSocketById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorMotherBoardsSocket.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_motherboardsocket_list = state.processor_motherboardsocket_list.map((processor_motherboards_socket) =>
          processor_motherboards_socket.id === action.payload.id ? action.payload : processor_motherboards_socket
        );
      })
      .addCase(addProcessorMotherBoardsSocket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Processor MotherBoards Chips";
      })
      .addCase(updateProcessorMotherBoardsSocket.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_motherboardsocket_list = state.processor_motherboardsocket_list.map((processor_motherboards_socket) =>
          processor_motherboards_socket.id === action.payload.id ? action.payload : processor_motherboards_socket
        );
      })
      .addCase(updateProcessorMotherBoardsSocket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Processor MotherBoards Chips";
      })
      .addCase(updateStatusInProcessorMotherBoardsSocket.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorMotherBoardsSocket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
